module.exports = __webpack_public_path__ + "static/images/step8.0b19381.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step/step8.png
// module id = 8Rsv
// module chunks = 1